import {AudienceTestStoreUtils} from "@/modules/maudiences/database/AudienceTestStoreUtils";
import {AudienceTestModel} from "@/modules/maudiences/models/AudienceTestModel";
import firebase from "firebase";
import {deserialize} from "serializr";
import {AudienceModel} from "@/modules/maudiences/models/AudienceModel";

export default {
    namespaced: true,
    state: {
        mABTests:[],
        mActiveTest:'',
    },
    getters: {
        getABTests: state => {
            return state.mABTests;
        },
        getActiveTest: state => {
            return state.mActiveTest;
        },
        getAudiences: state => {
            let final = []
            for (let a in state.mABTests) {
                for (let n in state.mABTests[a].audiences) {
                    let name = state.mABTests[a].audiences[n].name
                    if (final.find(e => e.name == name) == null){
                        final.push(state.mABTests[a].audiences[n])
                    }
                }
            }
            if (final.length == 0){
                return [new AudienceModel('def', 100)];
            }
            return final.sort((a, b) => a.name.localeCompare(b.name))
            //let active = state.mABTests.find(e => e.id == state.mActiveTest)
            //if (state.mActiveTest != "", active != null){
                //return active.audiences.map(e => e.copy()).sort((a, b) => a.name.localeCompare(b.name))
            //}
        },
        getCustomAudiences: () => {
            return [
                new AudienceModel('a'),
                new AudienceModel('b'),
                new AudienceModel('c'),
                new AudienceModel('d'),
                new AudienceModel('e'),
                new AudienceModel('f'),
                new AudienceModel('g'),
                new AudienceModel('h'),
                new AudienceModel('i'),
                new AudienceModel('j'),
                new AudienceModel('k'),
                new AudienceModel('l'),
                new AudienceModel('m'),
                new AudienceModel('n'),
                new AudienceModel('o'),
                new AudienceModel('p'),
                new AudienceModel('r'),
                new AudienceModel('s'),
                new AudienceModel('t'),
                new AudienceModel('u'),
                new AudienceModel('v'),
                new AudienceModel('w'),
                new AudienceModel('x'),
                new AudienceModel('y'),
                new AudienceModel('z'),
                new AudienceModel('expd')
            ];
        },
    },
    mutations: {
        setABTests(state, values) {
            state.mABTests = values;
        },
        setActiveTest(state, values) {
            state.mActiveTest = values;
        },
    },
    actions: {
        init(/*{commit}*/) {
            console.info('audiences-test-store initialized.');
            return AudienceTestStoreUtils.fetchAudienceTests()
        },
        fetchAudienceTests({commit}){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getABTestList', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return data.text()
                                        .then((data)=>{
                                            let parsedJson = JSON.parse(data);
                                            if (Object.keys(parsedJson).length == 0){
                                                return Promise.resolve('Succes')
                                            }else{
                                                if (Object.hasOwn(parsedJson, 'tests')){
                                                    commit("setABTests", parsedJson.tests.map(v => deserialize(AudienceTestModel, v)));
                                                }
                                                if (Object.hasOwn(parsedJson, 'active')){
                                                    commit("setActiveTest", parsedJson.active);
                                                }
                                            }
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        newABTest({/*commit*/}, data){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(data)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'newABTest', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return AudienceTestStoreUtils.fetchAudienceTests()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        updateABTest({/*commit*/}, data){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(data)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'updateABTest/'+ data.id, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return AudienceTestStoreUtils.fetchAudienceTests()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        deleteABTest({/*commit*/}, testId){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "DELETE",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'deleteABTest/' + testId, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return AudienceTestStoreUtils.fetchAudienceTests()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        setABTestActive({commit}, testId){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "PUT",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'setABTestActive/' + testId, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    commit("setActiveTest", testId);
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
    }
}

